module.exports = __webpack_public_path__ + "img/goods4_1.ab301512.jpg";